import React, { FC } from 'react';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { BaseButton } from '../../../../../../../BaseComponents';

interface Props {
	className?: string;
	onClickRules?: () => void;
	onClickConditions?: () => void;
	isFareRulesDisabled?: boolean;
}

const FooterLinks: FC<Props> = ({ className, onClickRules, onClickConditions, isFareRulesDisabled }) => {
	const { FooterLinks: css } = useTheme('Entities').FareGroupV2;
	const { t } = useTranslation('FareGroup');

	return (
		<div className={cn(css.root, className, { [css.oneLink]: !onClickRules || !onClickConditions })}>
			<BaseButton className={css.rules} variant="text" onClick={onClickRules} disabled={isFareRulesDisabled}>
				{t('Fare rules')}
			</BaseButton>

			{!!onClickConditions && (
				<BaseButton className={css.conditions} variant="text" onClick={onClickConditions}>
					{t('View full conditions')}
				</BaseButton>
			)}
		</div>
	);
};

export default FooterLinks;
